const loadPendo = (pendo, user) => {
  if (pendo) {
    pendo.identify({
      visitor: {
        uid: user.uid,
        email: user.email,
        first_name: user.firstName,
        last_name: user.lastName,
        job_title: user.jobTitle,
      },
      account: {
        org_uid: user.organizationUid,
        org_name: user.businessName,
      },
    });
  }
};

const addPendo = (pendo, user) => {
  if (pendo) {
    pendo.initialize();
  }

  if (user) {
    loadPendo(pendo, user);
  }

  return null;
};

export default addPendo;
